<template>
    <v-container fluid class="b-container">
        <v-sheet class="pa-3">
            <v-tabs
                v-model="tab"
                :vertical="$vuetify.breakpoint.mdAndDown"
                color="secondary"
                class="d-flex"
            >
                <v-tab
                    v-for="tab in tabs"
                    :key="tab.name['en']"
                    v-text="tab.name[lang]"
                    :to="tab.to"
                    class="
                        text-capitalize
                        d-flex
                        justify-md-center
                        px-3
                        flex-column
                    "
                ></v-tab>
            </v-tabs>
        </v-sheet>

        <v-tabs-items v-model="tab" class="mt-3">
            <router-view></router-view>
        </v-tabs-items>
    </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "Subscriptions",

    data() {
        return {
            tab: this.$route.path
        };
    },

    computed: {
        lang() {
            return this.$route.params.lang;
        },

        paymentError() {
            return this.$store.state.loyaltyPanel.paymentError;
        },

        tabs() {
            let arr = [];

            if (!this.paymentError) {
                arr.push({
                    name: { el: "Καταστήματα", en: "stores", it: "Negozi" },
                    to: `/${this.lang}/loyaltyPanel/subscriptions/stores`
                });
                if (this.getPermission('subscriptions.plans.read')) {
                    arr.push({
                        name: {
                            el: "Πλάνα Συνδρομής",
                            en: "Subscription Plans",
                            it: "Piani di abbonamento"
                        },
                        to: `/${this.lang}/loyaltyPanel/subscriptions/registration-plans`
                    });
                }

               
                if (this.getPermission('subscriptions.store_payment_methods.read')) {

                    arr.push({
                        name: {
                            el: "Μέθοδοι Πληρωμών",
                            en: "payment methods",
                            it: "Metodi di pagamento"
                        },
                        to: `/${this.lang}/loyaltyPanel/subscriptions/payment-methods`
                    });
                }
            }

            return arr;
        }
    },
    methods: {
        ...mapActions(["getPermission"])
    },
    watch: {
        $route: {
            immediate: true,
            handler(val) {
                if (val.path === `/${this.lang}/loyaltyPanel/subscriptions`) {
                    this.$router.push(
                        `/${this.lang}/loyaltyPanel/subscriptions/stores?page=1`
                    );
                }
            }
        }
    }
};
</script>
<style lang="scss">
.theme--light.v-tabs > .v-tabs-bar {
    width: 100%;
}

.v-tabs-bar.v-item-group > * {
    width: 100%;
}

.v-slide-group__content {
    width: 100%;
}

.my-subscription {
    background-color: #2a3042;
    color: white !important;
    border-radius: 5px 5px 0px 0px;
}
</style>
